module.exports = __webpack_public_path__ + "img/syukyaku-de-pa001.ce5d727b.png";